/**
 * Доля хвоста публичного рендерера: вид `trust_badges` (значки доверия).
 *
 * WEB-2920, заход 2: перенесено из `PublicBlockRendererExtended.tsx` слово в
 * слово. Метка `case 'trust_badges'` и хуки остаются в фасаде; ветка вида —
 * функция отрисовки `renderTrustBadges(ctx)`, замыкания фасада приходят
 * объектом-контекстом (`ExtendedRenderContext`). Эту долю импортирует только
 * фасад: она едет в ленивом куске `extended`, а не в первом экране
 * (самопроверка обхода).
 */
import type React from 'react';
import { TrustBadgeIcon, trustBadgeLabel } from '../trustBadgeIcons';
import type { ExtendedRenderContext } from '../PublicBlockRendererExtended';
// WEB-2963: доля в ленивом куске `extended` — импорт набора снятых способов
// оплаты первый экран не утяжеляет.
import { withoutRetiredTrustBadges } from '../paymentBannerOffer';

/** Ветка `trust_badges` фасада — тело `case` слово в слово. */
export function renderTrustBadges(
  ctx: ExtendedRenderContext,
): React.ReactElement {
  const { block } = ctx;
  // WEB-693: прозрачные SVG-значки вместо текстовых чипов на белом фоне.
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 16,
        marginBottom: 16,
      }}
    >
      {/* WEB-2963: снятый способ оплаты (PayPal) из старых данных покупателю
          не рисуется — оплата принимает только карту (WEB-1449). */}
      {withoutRetiredTrustBadges(block.trustBadgeItems).map((badge) => (
        <span
          key={badge}
          title={trustBadgeLabel(badge)}
          style={{ display: 'inline-flex', opacity: 0.9 }}
        >
          {/* WEB-1692: высота значка от автора; absent = умолчание
              компонента (28px), то есть сегодняшний вид до пикселя. */}
          <TrustBadgeIcon badge={badge} height={block.trustBadgeSizePx} />
        </span>
      ))}
    </div>
  );
}
